import { $alerts } from '@/components/AlertDialogs';

export async function alert({
  title,
  message,
  bgDismiss = true,
}: {
  title: string;
  message: string;
  bgDismiss?: boolean;
}) {
  return new Promise<void>(resolve => {
    $alerts.set({
      title,
      message,
      confirmText: 'OK',
      cancelText: null,
      bgDismiss,
      onConfirm: () => {
        $alerts.set(null);
        resolve();
      },
      onCancel: () => {
        $alerts.set(null);
        resolve();
      },
    });
  });
}

export async function confirm({
  title,
  message,
  bgDismiss = false,
  confirmText = 'OK',
  cancelText = 'Cancel',
}: {
  title: string;
  message: string;
  bgDismiss?: boolean;
  confirmText?: string;
  cancelText?: string;
}) {
  return new Promise<boolean>(resolve => {
    $alerts.set({
      title,
      message,
      confirmText,
      cancelText,
      bgDismiss,
      onConfirm: () => {
        $alerts.set(null);
        resolve(true);
      },
      onCancel: () => {
        $alerts.set(null);
        resolve(false);
      },
    });
  });
}

export async function ask({
  title,
  message,
  bgDismiss = true,
}: {
  title: string;
  message: string;
  bgDismiss?: boolean;
}) {
  return confirm({
    title,
    message,
    bgDismiss,
    confirmText: 'Yes',
    cancelText: 'No',
  });
}
